import { useState } from "react";
import { Send, Sparkles, Loader2, Trash2, AlertTriangle } from "lucide-react";
import { DIMS } from "@/components/rolemap/RoleProfile";

export default function RoleAsk({ session, ai, setAi, busy, onAsk, onSuggest, onRemoveEntry }) {
  const [q, setQ] = useState("");
  const [a, setA] = useState("");
  const [dim, setDim] = useState("");
  const submit = async () => {
    if (!q.trim()) return;
    await onAsk({ question: q.trim(), answer: a.trim(), dimension: dim || null, ai });
    setQ("");
    setA("");
    setDim("");
  };
  return (
    <div data-testid="role-ask">
      <div className="flex items-center justify-between gap-3">
        <div className="font-mono-label text-[10px] text-[#9a7218]">Ask · listen · capture</div>
        <label className="inline-flex items-center gap-2 text-xs text-[#55625b] cursor-pointer">
          <input data-testid="ai-toggle" type="checkbox" checked={ai} onChange={(e) => setAi(e.target.checked)} className="accent-[#9a7218]" />
          AI sorts and synthesises
        </label>
      </div>
      <input
        data-testid="ask-question-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Your question to the hiring manager"
        className="mt-3 w-full h-11 px-3 text-sm border border-[#e5e0d8] rounded-md bg-white focus:outline-none focus:border-[#9a7218]"
      />
      <textarea
        data-testid="ask-answer-input"
        value={a}
        onChange={(e) => setA(e.target.value)}
        placeholder="What they said (type while they talk, shorthand is fine)"
        rows={4}
        className="mt-2 w-full px-3 py-2 text-sm border border-[#e5e0d8] rounded-md bg-white focus:outline-none focus:border-[#9a7218]"
      />
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <select data-testid="ask-dimension-select" value={dim} onChange={(e) => setDim(e.target.value)} className="h-9 px-2 text-xs border border-[#e5e0d8] rounded-md bg-white">
          <option value="">{ai ? "Dimension: let AI decide" : "Dimension"}</option>
          {DIMS.map((d) => <option key={d.key} value={d.key}>{d.label}</option>)}
        </select>
        <button data-testid="ask-submit-btn" onClick={submit} disabled={busy || !q.trim()} className="h-9 px-4 rounded-full btn-guide text-xs font-medium inline-flex items-center gap-1.5 disabled:opacity-50">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />} Capture
        </button>
        <button data-testid="suggest-btn" onClick={onSuggest} disabled={busy} className="ml-auto h-9 px-3 rounded-full border border-[#14352a] text-xs inline-flex items-center gap-1.5 hover:bg-[#14352a] hover:text-white disabled:opacity-50">
          <Sparkles className="h-3.5 w-3.5" /> Suggest next questions
        </button>
      </div>

      {(session.suggestions?.length > 0 || session.gaps?.length > 0) && (
        <div data-testid="suggestions" className="mt-4 p-4 bg-[#f6efdc] border border-[#e2c982] rounded-lg">
          {session.gaps?.map((g, i) => (
            <p key={i} className="flex gap-2 text-xs text-[#55625b]"><AlertTriangle className="h-3.5 w-3.5 shrink-0 text-[#9a7218]" />{g}</p>
          ))}
          <ul className="mt-2 flex flex-wrap gap-1.5">
            {session.suggestions?.map((s, i) => (
              <li key={i}>
                <button data-testid={`suggestion-${i}`} onClick={() => setQ(s)} className="text-left text-xs px-2.5 py-1.5 rounded-full bg-white border border-[#e2c982] hover:border-[#9a7218]">{s}</button>
              </li>
            ))}
          </ul>
        </div>
      )}

      <ol data-testid="entries" className="mt-5 space-y-2">
        {[...(session.entries || [])].reverse().map((e) => (
          <li key={e.id} data-testid={`entry-${e.id}`} className="group p-3 bg-white border border-[#e5e0d8] rounded-md text-sm">
            <div className="flex items-start gap-2">
              <div className="flex-1">
                <div className="font-medium text-[#14352a]">{e.question}</div>
                {e.answer && <div className="mt-1 text-[#55625b]">{e.answer}</div>}
                {e.flag && <div className="mt-1 flex gap-1.5 text-xs text-[#b3261e]"><AlertTriangle className="h-3.5 w-3.5 shrink-0" />{e.flag}</div>}
              </div>
              <span className="font-mono-label text-[8px] text-[#9a7218] whitespace-nowrap">{DIMS.find((d) => d.key === e.dimension)?.label.split(",")[0] || "unsorted"}</span>
              <button onClick={() => onRemoveEntry(e.id)} className="opacity-0 group-hover:opacity-100 text-[#86928a] hover:text-[#b3261e]" aria-label="Delete"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
